import { ArrowDownIcon } from './arrow-down-icon'
import { AttachNoteOutlinedIcon } from './attach-note-outlined-icon'
import { BrandLogoIcon } from './brand-logo-icon'
import { CheckDocIcon } from './check-doc-icon'
import { ConfluenceIcon } from './confluence-icon'
import { EditIcon } from './edit-icon'
import { ExpandAllIcon } from './expand-all-icon'
import { FilterOutlinedIcon } from './filter-outlined-icon'
import { FlagUSIcon } from './flag-us-icon'
import { FormatQuoteIcon } from './format-quote-icon'
import { GChatIcon } from './g-chat-icon'
import { IaIcon } from './ia-icon'
import { InfoOutlinedIcon } from './info-outlined-icon'
import { MenuCollapseOutlinedIcon } from './menu-collapse-outlined-icon'
import { OpenInNewIcon } from './open-in-new-icon'
import { OptiBotIcon } from './opti-bot-icon'
import { OptiIcon } from './opti-icon'
import { OptiNeutralIcon } from './opti-neutral-icon'
import { OptiSadIcon } from './opti-sad-icon'
import { OptiWinkIcon } from './opti-wink-icon'
import { OrderOutlinedIcon } from './order-outlined-icon'
import { PersonIcon } from './person-icon'
import { PersonOutlinedIcon } from './person-outlined-icon'
import { RotateLeftIcon } from './rotate-left-icon'
import { RotateRightIcon } from './rotate-right-icon'
import { SearchDocIcon } from './search-doc-icon'
import { SettingsOutlinedIcon } from './settings-outlined-icon'
import { SlackIcon } from './slack-icon'
import { SortIcon } from './sort-icon'
import { TimeIcon } from './time-icon'
import { WbIncandescentIcon } from './wb-incandescent-icon'

export const ICONS = {
  arrowDown: ArrowDownIcon,
  attachNoteOutlined: AttachNoteOutlinedIcon,
  brandLogo: BrandLogoIcon,
  checkDoc: CheckDocIcon,
  confluence: ConfluenceIcon,
  edit: EditIcon,
  expandAll: ExpandAllIcon,
  flagUS: FlagUSIcon,
  filterOutlined: FilterOutlinedIcon,
  formatQuote: FormatQuoteIcon,
  gChat: GChatIcon,
  ia: IaIcon,
  infoOutlined: InfoOutlinedIcon,
  menuCollapseOutlined: MenuCollapseOutlinedIcon,
  openInNew: OpenInNewIcon,
  optiBot: OptiBotIcon,
  opti: OptiIcon,
  optiNeutral: OptiNeutralIcon,
  optiSad: OptiSadIcon,
  optiWink: OptiWinkIcon,
  orderOutlined: OrderOutlinedIcon,
  person: PersonIcon,
  personOutlined: PersonOutlinedIcon,
  rotateLeft: RotateLeftIcon,
  rotateRight: RotateRightIcon,
  searchDoc: SearchDocIcon,
  settingsOutlined: SettingsOutlinedIcon,
  slack: SlackIcon,
  sort: SortIcon,
  time: TimeIcon,
  wbIncandescent: WbIncandescentIcon,
}

export type IconName = keyof typeof ICONS
